// 1. Import it at the top
import loaderGif from '../../assets/images/page-loader.gif'; 

const GifLoader = () => {
const gifSource = `${loaderGif}?t=${new Date().getTime()}`;
  return (
    <div style={styles.container}>
      {/* 2. Use the imported variable, NOT a string path */}
      <img src={gifSource} alt="Loading..." style={{ width: '100px' }} />
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 99999,
    // This creates the "transparency" without a white flash
    backgroundColor: 'rgba(0, 0, 0, 0.4)', 
    // This blurs the content BEHIND the loader without changing its CSS
    backdropFilter: 'blur(6px) brightness(0.7)',
    WebkitBackdropFilter: 'blur(6px) brightness(0.7)', // Support for Safari
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loaderContainer: {
    textAlign: 'center',
  },
  gif: {
    width: '150px',
    height: 'auto',
    display: 'block',
  }
};

export default GifLoader;